import { render } from "./MethanizationDataForm.vue?vue&type=template&id=bd2a47ac&scoped=true&ts=true"
import script from "./MethanizationDataForm.vue?vue&type=script&lang=ts"
export * from "./MethanizationDataForm.vue?vue&type=script&lang=ts"

import "./MethanizationDataForm.vue?vue&type=style&index=0&id=bd2a47ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd2a47ac"]])

export default __exports__